const session = {
  title: "퀴즈",
  incorrectOnly: "(오답 문제만)",
  completed: "퀴즈 완료!",
  resultSummary: "{{totalCount}}문제 중 {{correctCount}}문제를 맞추셨습니다.",
  feedbackExcellent: "훌륭해요! 학습 내용을 잘 이해하셨네요!",
  feedbackGood: "좋아요! 조금 더 복습하면 완벽해질 거예요!",
  feedbackEncourage: "괜찮아요! 다시 한번 학습하고 도전해보세요!",
  retake: "다시 풀기",
  done: "완료",
  previous: "이전",
  next: "다음",
  jumpToQuestion: "문제 바로가기",
  failedToLoad: "퀴즈를 불러오는데 실패했습니다.",
  retry: "다시 시도",
  noIncorrectQuestions: "오답 문제가 없습니다.",
  noQuizForContent: "이 콘텐츠에 연결된 퀴즈가 없습니다."
};
const container = {
  checkAnswerError: "정답 확인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  unsupportedType: "이 문제 유형({{type}})은 아직 지원되지 않습니다.",
  questionNumber: "{{number}}번",
  correctRate: "정답률 {{rate}}%",
  containsVariables: "변수 포함. {{variables}}",
  questionImage: "문제 이미지",
  submitting: "제출 중...",
  checkAnswer: "정답 확인"
};
const types = {
  boolean: {
    label: "맞아요 틀려요",
    correct: "맞아요",
    incorrect: "틀려요",
    selectLabel: "맞아요 틀려요 선택"
  },
  fillBlank: {
    label: "빈칸 채우기",
    placeholder: "빈칸",
    answer: "정답:",
    hint: "힌트:"
  },
  dragText: {
    label: "박스 채우기",
    blank: "?",
    "delete": "삭제",
    selectFromChoices: "보기에서 선택하세요:"
  },
  selectText: {
    label: "선택하기",
    placeholder: "?",
    answer: "정답:"
  },
  multiChoice: {
    label: "정답 고르기",
    selectCount: "{{count}}개 선택",
    selectInstruction: "{{count}}개를 선택해주세요 ({{selected}}/{{count}} 선택됨)",
    selectOne: "하나를 선택해주세요",
    optionAlt: "보기 {{number}}",
    selectOption: "보기 선택"
  },
  inline: {
    label: "인라인",
    childLabel: "문제 {{n}}",
    partialResult: "{{correct}}/{{total}} 맞췄어요"
  },
  coloring: {
    label: "색칠하기",
    correctAnswerErase: "정답은 {{count}}개를 지워야 해요.",
    correctAnswerColor: "정답은 {{count}}개를 색칠해야 해요.",
    erased: "{{count}}개를 지웠어요.",
    colored: "{{count}}개를 색칠했어요.",
    eraseCount: "{{count}}개 지우기",
    colorCount: "{{count}}개 색칠"
  },
  counting: {
    label: "수 세기",
    incrementDigit: "{{position}}번째 자리 올리기",
    decrementDigit: "{{position}}번째 자리 내리기"
  },
  ordering: {
    label: "순서 맞추기",
    dragInstruction: "드래그하여 순서를 바꿔주세요",
    moveUp: "위로 이동",
    moveDown: "아래로 이동"
  },
  pairing: {
    label: "짝 맞추기",
    matchPairs: "짝을 맞춰주세요",
    selectMatch: "짝을 선택하세요"
  },
  imageSelect: {
    label: "이미지 선택",
    selectArea: "영역을 선택해주세요"
  },
  newFillBlank: {
    label: "주관식",
    note: "※ 작성하신 내용은 교육 수료 후 AIQ 리포트에서 확인할 수 있습니다.",
    placeholder: "예시)최근 고객 데이터를 분석할 일이 있었는데, 평균이 3.5점이라 대수롭지 않게 넘겼다. 하지만…",
    submit: "제출",
    submitted: "답안이 제출되었습니다."
  },
  newMultiChoice: {
    label: "복수 선택",
    selectCount: "{{count}}개 선택",
    selectedProgress: "{{selected}}/{{count}} 선택됨",
    selectOption: "보기를 선택해주세요",
    submit: "제출",
    submitted: "답안이 제출되었습니다."
  },
  newSelectText: {
    label: "단일 선택",
    selectOption: "선택",
    submit: "제출",
    submitted: "답안이 제출되었습니다."
  }
};
const feedback = {
  correct: "정답입니다!",
  correctMessage: "잘했어요, 계속 이렇게!",
  incorrect: "오답입니다",
  submitted: "제출 완료",
  submittedMessage: "선생님이 답안을 확인하고 있어요.",
  explanation: "설명"
};
const common = {
  checkAnswer: "정답 확인",
  viewMyAnswer: "내 답안보기",
  viewCorrectAnswer: "정답보기",
  correct: "정답",
  score: "획득 점수: {{score}}점",
  scorePoints: "{{score}}점",
  feedbackCorrect: "잘했어요! 다음 문제도 도전해보세요!",
  feedbackIncorrect: "틀려도 괜찮아요. 해설을 읽고 다시 한번 생각해보세요!",
  optionAlt: "선택지 {{number}}"
};
const overlay = {
  warmupQuiz: "워밍업 문제",
  reviewQuiz: "복습 문제",
  moduleStartQuiz: "모듈 시작 퀴즈",
  moduleEndQuiz: "모듈 마무리 퀴즈",
  startQuiz: "시작 퀴즈",
  endQuiz: "종료 퀴즈"
};
const shared = {
  blank: "빈칸",
  explanation: "해설",
  explanationImage: "해설 이미지",
  cannotLoadGraph: "그래프를 불러올 수 없습니다: {{error}}",
  cannotLoadVideo: "영상을 불러올 수 없습니다.",
  copyQuizId: "Quiz ID 복사",
  viewInAdmin: "Admin에서 퀴즈 보기"
};
const toggle = {
  correctAndExplanation: "정답과 풀이",
  myAnswer: "내가 쓴 답"
};
const result = {
  popup: {
    correctAriaLabel: "정답",
    correctComboAriaLabel: "정답 콤보 3연속",
    wrongAriaLabel: "오답",
    wrongComboAriaLabel: "오답 3연속"
  }
};
const quizKo = {
  session,
  container,
  types,
  feedback,
  common,
  overlay,
  shared,
  toggle,
  result
};
export {
  common,
  container,
  quizKo as default,
  feedback,
  overlay,
  result,
  session,
  shared,
  toggle,
  types
};
//# sourceMappingURL=quiz.json.js.map
